// Web map tiles (spec 005 FR-044): explorer tiles are the zoom-14 tiles
// of the slippy map scheme, x growing east and y growing south from the
// north-west corner. This file imports nothing, so its tests run under node.

// tileLon is the longitude of a tile column's west edge.
export function tileLon(x: number, zoom: number): number {
  return (x / 2 ** zoom) * 360 - 180;
}

// tileLat is the latitude of a tile row's north edge, from the inverse Web
// Mercator projection.
export function tileLat(y: number, zoom: number): number {
  const n = Math.PI - (2 * Math.PI * y) / 2 ** zoom;
  return (180 / Math.PI) * Math.atan(Math.sinh(n));
}

// tileRing is the closed [lon, lat] outline of the block of size by size
// tiles whose north-west tile is x, y: one tile at size 1, or the largest
// square of tiles.
export function tileRing(x: number, y: number, zoom: number, size = 1): [number, number][] {
  const w = tileLon(x, zoom), e = tileLon(x + size, zoom);
  const n = tileLat(y, zoom), s = tileLat(y + size, zoom);
  return [[w, n], [e, n], [e, s], [w, s], [w, n]];
}
